import { ReactNode, useEffect, useState } from 'react';
import { deleteData, postData } from '../backend';
import { useModal } from '../contexts';
import { ClipboardCopyIcon } from '@heroicons/react/outline';
import CopyToClipboard from 'react-copy-to-clipboard';
import Modal from './Modal';
import useUser from '../hooks/useUser';

function SettingsModalZapier() {
  const { user, refreshUser } = useUser();
  const { closeModal } = useModal();
  const [isCopied, setIsCopied] = useState(false);

  function handleDeleteZapierCredentials() {
    if (user?.zapierCredentials)
      deleteData(`/zapier/credentials/${user.zapierCredentials.id}/`)
        .then(refreshUser)
        .catch(console.error)

    closeModal();
  }

  function handleCopyApiKey() {
    setIsCopied(true);
    setTimeout(() => setIsCopied(false), 1000);
  }

  useEffect(() => {
    if (!user?.zapierCredentials)
      postData("/zapier/credentials/")
        .then(refreshUser)
        .catch(console.error);
  }, [user, refreshUser]);

  let modalContent: ReactNode
  if (user?.zapierCredentials?.zapierApiKey)
    modalContent = <>
      <input type="text" className="w-full text-sm bg-gray-100 text-gray-600 border rounded-sm outline-none h-8 px-2" value={user.zapierCredentials.zapierApiKey} onClick={e => e.currentTarget.select()} readOnly />
      <CopyToClipboard text={user.zapierCredentials.zapierApiKey} onCopy={handleCopyApiKey}>
        <button className="relative flex items-center justify-center border bg-white h-8 w-8 flex-shrink-0 rounded-sm group shadow-sm">
          <ClipboardCopyIcon className="h-4 w-4 group-hover:text-blue" />
          <div className="hidden group-hover:block absolute bg-black text-white whitespace-nowrap text-xs top-9 right-4 py-1 px-2 rounded-md rounded-tr-none">
            {isCopied ? "Copied" : "Copy to clipboard"}
          </div>
        </button>
      </CopyToClipboard>
    </>
  else
    modalContent = <div>Generating API key...</div>

  return (
    <Modal>
      <div className='flex flex-col' style={{ width: 400 }}>
        <div className="text-xl font-gilroy font-bold mb-4">Zapier API Key</div>

        <div className="text-gray-600 text-sm mb-2">Please follow our <a href="https://www.portant.co/guide-article/how-to-connect-a-glide-data-source" target="_blank" rel="noreferrer" className="text-blue underline font-semibold cursor-pointer hover:underline">Zapier Integration Guide</a> to configure this field.</div>

        <div className="flex items-center gap-2">
          {modalContent}
        </div>

        <div className='flex justify-between'>
          <button className='btn btn-white hover:btn-red mt-4' onClick={handleDeleteZapierCredentials}>Delete</button>
        </div>
      </div>
    </Modal>
  );
}

export default SettingsModalZapier;
